'use strict';
failedCheckPrintLogController.$inject = ['$scope', '$rootScope', '$q', '$interval', 'dialogHelper', 'reportHelper', 'bankService', 'BUSY_MESSAGE'];
angular.module('schoolLinqApp').controller('failedCheckPrintLogController', failedCheckPrintLogController);

function failedCheckPrintLogController($scope, $rootScope, $q, $interval, dialogHelper, reportHelper, bankService, BUSY_MESSAGE) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.loadingPromise = $q.all([$scope.vm.loadBanks($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			message: BUSY_MESSAGE.Loading,
			filter: {
				bank: null,
				dateFrom: moment().toDate(),
				dateTo: moment().toDate(),
				allDates: false,
			},
			validationErrors: [],
			errors: null,
		};

		function loadBanks(model) {
			return bankService.getBanks(false, true).then(_.partial(finishLoadingBanks, model));

			function finishLoadingBanks(model, response) {
				model.banks = response.data.banks;

				var bObj = {
					Id: 0,
					BankName: 'All',
					ShortName: 'All',
					DisplayName: 'All',
				};

				model.banks.unshift(bObj);
				model.filter.bank = model.banks[0];
				return angular.noop;
			}
		}

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (model.filter.allDates !== true) {
				if (!model.filter.dateFrom) {
					model.validationErrors.push("Please select a 'From' date.");
					isValid = false;
				}

				if (!model.filter.dateTo) {
					model.validationErrors.push("Please select a 'To' date.");
					isValid = false;
				}

				if (isValid === true && moment(model.filter.dateFrom).startOf('day') > moment(model.filter.dateTo).startOf('day')) {
					model.validationErrors.push('Date Range is invalid!');
					isValid = false;
				}
			}
			return isValid;
		}

		function openReport(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Validation Errors', null, model.validationErrors, 'Warning');
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			if (!model.filter.dateFrom) {
				model.filter.dateFrom = moment().toDate();
			}
			if (!model.filter.dateTo) {
				model.filter.dateTo = moment().toDate();
			}

			var report = {
				BankId: model.filter.bank.Id || 0,
				BankName: model.filter.bank.ShortName,
				AllDates: model.filter.allDates,
				DateFrom: moment(model.filter.dateFrom).format('l'),
				DateTo: moment(model.filter.dateTo).format('l'),
			};

			reportHelper.getReport($scope, '/api/fundreports/failedcheckprintlog', report, 'FailedCheckPrintLogReport.pdf');
		}

		return angular.extend(model, {
			loadBanks: _.partial(loadBanks, model),
			openReport: _.partial(openReport, model),
		});
	}
}
